const dataManage = () => import("../views/report/index");
export default {
    path: "/report",
    name: "report",
    hideInMenu: true,
    meta: {
        icon: "iconfont iconshujuguanli",
        title: "健康报告",
        lang_key: "porject.view_report",
        // authority: ["0", "1", "2", "3"]
    },
    component: dataManage,
    children: [
        {
            path: "/report",
            redirect: "/report/list"
        },
        {
            path: "/report/list", //subject_id&task_id
            name: "reportList",
            component: () => import("../views/report/reportList"),
            meta: { keepAlive: false }
        },
        {
            path: "/report/create", //subject_id&task_id
            name: "reportCreate",
            component: () => import("../views/report/reportCreate"),
            meta: { keepAlive: false }
        },
    ]
}